import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ForeignBankAccountFormModel } from './foreign-bank-account-form.model';
import { KontoBankowe } from '../../../../models/konto-bankowe';
import { SharedValidators } from '../../../../validators/shared-validators';

export class ForeignBankAccountFormBuilder {
  public static createFormGroup(
    bankAccount?: KontoBankowe,
  ): FormGroup<ForeignBankAccountFormModel> {
    return new FormGroup<ForeignBankAccountFormModel>({
      numerKonta: new FormControl(bankAccount?.numerKonta || null),
      daneBanku: new FormControl(bankAccount?.daneBanku || null, [
        Validators.maxLength(350),
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      identyfikatorBanku: new FormControl(
        bankAccount?.identyfikatorBanku || null,
      ),
    });
  }

  public static toModel(
    formGroup: FormGroup<ForeignBankAccountFormModel>,
  ): KontoBankowe {
    const kontoBankowe = new KontoBankowe();

    kontoBankowe.numerKonta = formGroup.controls.numerKonta.value;
    kontoBankowe.daneBanku = formGroup.controls.daneBanku.value;
    kontoBankowe.identyfikatorBanku =
      formGroup.controls.identyfikatorBanku.value;
    kontoBankowe.czyZagraniczne = true;

    return kontoBankowe;
  }
}
